module.exports = "/images/lena.png?f7d9185f55e2f8646e99297c7687c3ef";